import { createIconComponent } from '../createIconComponent';
import { createIconFromSvg } from '../createIconFromSvg';

export const Cross = createIconComponent(
  createIconFromSvg({
    tag: 'svg',
    attr: {
      viewBox: '0 0 25 25',
      fill: 'none',
    },
    child: [
      {
        tag: 'path',
        attr: {
          d: 'M6.50928 18.6382L17.823 7.32445',
          stroke: 'currentColor',
          strokeWidth: '2.1',
          strokeLinecap: 'round',
        },
        child: [],
      },
      {
        tag: 'path',
        attr: {
          d: 'M17.823 18.6382L6.50929 7.32445',
          stroke: 'currentColor',
          strokeWidth: '2.1',
          strokeLinecap: 'round',
        },
        child: [],
      },
    ],
  })
);
